import { createRouter, createWebHistory } from "vue-router";
import LoginComponent from "../components/login.vue";
import QuanLyNguoiDungComponent from "../components/quan-ly-tai-khoan.vue";
import QuanLyProjectsComponent from "../components/quan-ly-projects.vue";
import QuanLyCongTyComponent from "../components/quan-ly-cong-ty.vue";
import QuanLyModulesComponent from "../components/quan-ly-modules.vue";
import QuanLyRolesComponent from "../components/quan-ly-roles.vue";
import PhanQuyenUserComponent from "../components/phan-quyen-user.vue";
import QuenMatKhauComponent from "../components/quen-mat-khau.vue";
import ResetPasswordComponent from "../components/reset-password.vue";
import userInfoComponent from "@/components/user-info.vue";

import VueCookies from "vue-cookies";

const routes = [
  {
    path: "/login",
    name: "LoginComponent",
    component: LoginComponent,
  },
  {
    path: "/user-info",
    name: "UserInfoComponent",
    component: userInfoComponent,
    meta: { requiresAuth: true },
  },
  {
    path: "/quan-ly-nguoi-dung",
    name: "QuanLyNguoiDungComponent",
    component: QuanLyNguoiDungComponent,
    meta: { requiresAuth: true },
  },
  {
    path: "/quan-ly-cong-ty",
    name: "QuanLyCongTyComponent",
    component: QuanLyCongTyComponent,
    meta: { requiresAuth: true },
  },
  {
    path: "/quan-ly-projects",
    name: "QuanLyProjectsComponent",
    component: QuanLyProjectsComponent,
    meta: { requiresAuth: true },
  },
  {
    path: "/quan-ly-modules",
    name: "QuanLyModulesComponent",
    component: QuanLyModulesComponent,
    meta: { requiresAuth: true },
  },
  {
    path: "/quan-ly-roles",
    name: "QuanLyRolesComponent",
    component: QuanLyRolesComponent,
    meta: { requiresAuth: true },
  },
  {
    path: "/phan-quyen-user",
    name: "PhanQuyenUserComponent",
    component: PhanQuyenUserComponent,
    meta: { requiresAuth: true },
  },
  {
    path: "/quen-mat-khau",
    name: "QuenMatKhauComponent",
    component: QuenMatKhauComponent,
    meta: { requiresAuth: false },
  },
  {
    path: "/reset-password",
    name: "ResetPasswordComponent",
    component: ResetPasswordComponent,
    meta: { requiresAuth: true },
  },
  {
    path: "/:pathMatch(.*)*",
    redirect: "/login",
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

// Middleware kiểm tra đăng nhập
router.beforeEach((to, from, next) => {
  // const isAuthenticated = localStorage.getItem('auth'); // Hoặc kiểm tra token từ store
  // const isAuthenticated = this.$cookies.get('auth'); // Lấy token từ cookie
  const isAuthenticated = VueCookies.get("auth"); // Lấy token từ cookie
  if (to.meta.requiresAuth && !isAuthenticated) {
    // Nếu cần đăng nhập mà chưa đăng nhập, điều hướng về trang login
    next("/login");
  } else {
    // Nếu đã đăng nhập hoặc không cần bảo mật, cho phép điều hướng
    next();
  }
});

export default router;
